import * as yup from 'yup';
import { IFormSelectOption } from '../../../interfaces/forms/forms';

export interface IStepInfo {
	whoFillsOut: string;

	senderName: string;
	senderSsn: string;
	senderAddress: string;
	senderZip: IFormSelectOption;
	senderEmail: string;
	senderPhone: string;
	senderContact: string;
	senderIsForeign: boolean;
	senderForeignZip: string;
	senderForeignCity: string;
	senderForeignCountry: IFormSelectOption;

	receiverName: string;
	receiverSsn: string;
	receiverAddress: string;
	receiverZip: IFormSelectOption;
	receiverEmail: string;
	receiverPhone: string;
	receiverContact: string;
	receiverIsForeign: boolean;
	receiverForeignZip: string;
	receiverForeignCity: string;
	receiverForeignCountry: IFormSelectOption;
}
export const stepInfoInitalValues: IStepInfo = {
	whoFillsOut: '',

	senderName: '',
	senderSsn: '',
	senderAddress: '',
	senderZip: null,
	senderEmail: '',
	senderPhone: '',
	senderContact: '',
	senderIsForeign: false,
	senderForeignZip: '',
	senderForeignCity: '',
	senderForeignCountry: null,

	receiverName: '',
	receiverSsn: '',
	receiverAddress: '',
	receiverZip: null,
	receiverEmail: '',
	receiverPhone: '',
	receiverContact: '',
	receiverIsForeign: false,
	receiverForeignZip: '',
	receiverForeignCity: '',
	receiverForeignCountry: null,
};

const yupFormSelectOption = {
	label: yup.string(),
	value: yup.string(),
};

export const stepInfoSchema = yup.object().shape({
	senderName: yup.string().required('shared.required').max(44, 'step-info.tooLong'),
	senderSsn: yup.string().min(10, 'step-info.ssn-min').max(10, 'step-info.ssn-max'),
	senderAddress: yup.string().required('shared.required').max(35, 'step-info.tooLong'),
	senderZip: yup
		.object()
		.nullable()
		.shape(yupFormSelectOption)
		.when('senderIsForeign', {
			is: false,
			then: yup.object().nullable().shape(yupFormSelectOption).required('shared.required'),
		}),
	senderEmail: yup
		.string()
		.email('step-info.email-format')
		.when('whoFillsOut', {
			is: val => val === 'sender',
			then: yup.string().email('step-info.email-format').required('shared.required'),
			otherwise: yup.string().email('step-info.email-format'),
		}),
	senderPhone: yup
		.string()
		.min(7, 'step-info.phone-min')
		.max(15, 'step-info.phone-sender-max')
		// Sender phone is an icelandic phone number or cell number
		.matches(/^[0-9]*$/, 'step-info.name')
		.required('shared.required'),

	senderForeignZip: yup.string().when('senderIsForeign', {
		is: true,
		then: yup.string().required('shared.required').max(10, 'shared.max10'),
	}),

	senderForeignCity: yup.string().when('senderIsForeign', {
		is: true,
		then: yup.string().required('shared.required').max(35, 'step-info.tooLong'),
	}),

	senderForeignCountry: yup
		.object()
		.nullable()
		.shape(yupFormSelectOption)
		.when('senderIsForeign', {
			is: true,
			then: yup.object().nullable().shape(yupFormSelectOption).required('shared.required'),
		}),
	senderContact: yup.string().max(35, 'step-info.tooLong'),

	receiverName: yup.string().required('shared.required').max(44, 'step-info.tooLong'),
	receiverSsn: yup.string().min(10, 'step-info.ssn-min').max(10, 'step-info.ssn-max'),
	receiverAddress: yup.string().required('shared.required').max(35, 'step-info.tooLong'),
	receiverZip: yup
		.object()
		.nullable()
		.shape(yupFormSelectOption)
		.when('receiverIsForeign', {
			is: false,
			then: yup.object().nullable().shape(yupFormSelectOption).required('shared.required'),
		}),
	receiverEmail: yup
		.string()
		.email('step-info.email-format')
		.when('whoFillsOut', {
			is: val => val === 'recipient',
			then: yup.string().email('step-info.email-format').required('shared.required'),
			otherwise: yup.string().email('step-info.email-format'),
		}),
	receiverPhone: yup
		.string()
		// Receiver phone is an icelandic cell number.
		// If the shipment is international then this validation is removed
		.min(7, 'step-info.phone-min')
		.max(15, 'step-info.phone-recipient-max')
		.matches(/^[0-9]*$/, 'shared.required'),

	receiverForeignZip: yup.string().when('receiverIsForeign', {
		is: true,
		then: yup.string().required('shared.required').max(10, 'shared.max10'),
	}),

	receiverForeignCity: yup.string().when('receiverIsForeign', {
		is: true,
		then: yup.string().required('shared.required').max(35, 'step-info.tooLong'),
	}),
	receiverForeignCountry: yup
		.object()
		.nullable()
		.shape(yupFormSelectOption)
		.when('receiverIsForeign', {
			is: true,
			then: yup.object().nullable().shape(yupFormSelectOption).required('shared.required'),
		}),
	receiverContact: yup.string().max(35, 'step-info.tooLong'),
});
